// extracted by mini-css-extract-plugin
export default {"point":"AuditSection_point__FsAww","imageDiv":"AuditSection_imageDiv__L4n9r","image":"AuditSection_image__s1HhS"};